import React, { useEffect, useState } from 'react';
import { get, filter, isEmpty, map, includes, find } from 'lodash';
import moment from 'moment';
import { bool, func, array } from 'prop-types';
import classNames from 'classnames';
import {
    FlexContainer,
    Icon,
    ConditionalRender,
    Text,
    FormDatePicker,
    InnerAside,
    InnerAsideContent,
    FormSelect,
    Button,
    FormInput,
    CompanyGroupsSelect
} from '../../common';
import { storesKind } from '../../../utils/misc';

const Header = ({ collapsed, onClick }) => (
    <a
        href='#'
        onClick={() => onClick(!collapsed)}
        className={classNames('drawer-header', { 'collapsed': collapsed })}
        style={{ padding: '45px 15px 0 15px' }}
    >
        <Icon name='filters' right={5} style={{ lineHeight: 1.5 }} />
        <ConditionalRender condition={!collapsed}>
            <Text text='Filtrar por:' />
        </ConditionalRender>
    </a>
);

const Wrapper = ({ isMobile, reseting, children }) => {
    const [collapsed, setCollapsed] = useState(true);

    if (isMobile) {
        return (
            <ConditionalRender condition={!reseting}>
                { children }
            </ConditionalRender>
        );
    };
    return (
        <InnerAside closedWidth='40px' background='white' closed={collapsed}>
            <InnerAsideContent>
                <FlexContainer direction='column' minHeight='740px'>
                    <Header collapsed={collapsed} onClick={setCollapsed} />
                    <ConditionalRender condition={!collapsed && !reseting}>
                        { children }
                    </ConditionalRender>
                </FlexContainer>
            </InnerAsideContent>
        </InnerAside>
    );
};

const LeftFilters = ({
    sessionSalesChannel,
    reseting,
    onSubmit,
    isMobile
}) => {
    const [stores, setStores] = useState([]);
    const [name, setName] = useState('');
    const [storeKind, setStoreKind] = useState({ label: 'Jumbo', value: 'Jumbo' });
    const [status, setStatus] = useState(null);
    const [salesChannels, setSalesChannels] = useState({});
    const [creationDate, setCreationDate] = useState([moment(), moment()]);

    useEffect(() => filterStoresByStoreKind(), [storeKind]);
    useEffect(() => setSalesChannels(stores), [stores]);

    const filterStoresByStoreKind = () => {
        !isEmpty(get(storeKind, 'value'))
            ? setStores(filter(sessionSalesChannel, { kind: get(storeKind, 'value') }))
            : setStores(sessionSalesChannel);
    };

    const filters = {
        name,
        store_kind: get(find(storesKind, { name: get(storeKind, 'value') }), 'id'),
        status: includes([0, 1], get(status, 'value')) ? [get(status, 'value')] : [0, 1],
        salesChannel: map(salesChannels, 'value'),
        creation_date: [
            `${creationDate[0].format('YYYY-MM-DD')} 00:00:00`,
            `${creationDate[1].format('YYYY-MM-DD')} 23:59:59`
        ]
    };

    return (
        <Wrapper isMobile={isMobile} reseting={reseting}>
            <FlexContainer padding={15} direction='column'>
                <FormInput
                    label='Nombre'
                    onChange={({ target }) => setName(get(target, 'value'))}
                    value={name}
                />
                <FormDatePicker
                    mobile={isMobile}
                    label='Fecha de creación'
                    defaultValue={moment().subtract(29, 'days')}
                    range
                    onChange={(value) => setCreationDate(value)}
                    position='fixed'
                    portalStyle={{ top: '280px' }}
                />
                <CompanyGroupsSelect onChange={(value) => setStoreKind(value)} />
                <FormSelect
                    multiple
                    allSelected
                    label='Tienda'
                    options={stores}
                    value={salesChannels}
                    onChange={({ value }) => setSalesChannels(value)}
                />
                <FormSelect
                    label='Estado'
                    value={status}
                    options={[{ value: 1, label: 'Activo' }, { value: 0, label: 'Inactivo' }]}
                    onChange={({ value }) => setStatus(value)}
                />
            </FlexContainer>
            <FlexContainer pX={15}>
                <Button
                    link
                    text='Limpiar'
                    onClick={() => {}}
                />
                <Button
                    secondary
                    text='Aplicar'
                    onClick={() => onSubmit(filters)}
                />
            </FlexContainer>
        </Wrapper>
    );
};

Header.propTypes = {
    collapsed: bool,
    onClick: func
};

Header.defaultProps = {
    collapsed: true,
    onClick: () => {}
};

LeftFilters.propTypes = {
    sessionSalesChannel: array,
    reseting: bool,
    onSubmit: func,
    isMobile: bool
};

export default LeftFilters;
